import { Component, HostBinding, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { IntervalDirective } from '../../directives/interval.directive';
import { PageTitleDirective } from '../../directives/page-title.directive';
import { NavigationService } from '../../services/navigation.service';

@Component({
    selector: 'app-page404',
    templateUrl: './page404.component.html',
    styleUrls: ['./page404.component.scss'],
  imports: [SharedModule, PageTitleDirective, TranslatePipe]
})
export class Page404Component extends IntervalDirective {

  protected remainingSeconds = 10;

  private readonly navigationService = inject(NavigationService);

  @HostBinding('class')
  protected get layoutClass() {
    return `full-height-stack center flow-center`;
  }

  constructor() {
    super();
    this.startInterval(1000);
  }

  protected override onTick() {
    const remainingSeconds = this.remainingSeconds - 1;
    if (remainingSeconds <= 0) {
      this.stopInterval();
      this.navigationService.router.navigateByUrl(this.navigationService.initializationUrl);
      return;
    }
    this.remainingSeconds = remainingSeconds;
  }

}
